module.exports = {
  name: 'default',
  listClass: 'default',
  defaultLimit: 6,
  columns: 3,
  itemIndexes: null,
  gutterWidth: ''
}